import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit, isDevMode } from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { Registry } from '../registry/registry';
declare var Stripe;
@Component({
  selector: 'app-hitchd-cards--payment-page',
  templateUrl: './hitchd-cards-payment-page.component.html',
  styleUrls: ['./hitchd-cards-payment-page.component.scss']
})

export class HitchdCardsPaymentPageComponent implements OnInit {

  price= 0;
  currency: string;
  symbol: string;
  uuid: string;
 country: string;
 smallPrice = 0;
  registry: Registry;
  canUpgrade = false;
  type = null;
  expired = false;
  daysLeft = 0;
  tier: string;
  isEu: boolean;
  currentPrice: any;
  mode: string;




  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _registryFirebaseService: RegistryFirebaseService
  ) {

    document.title = 'Publish | Hitchd';
    this.route.queryParams
      .subscribe(params => {

        if (params['expired'] === 'true') {
          this.expired = true;

        } else {
          this.expired = false;
        }
      });

      this.route.data.subscribe(data => {
        this.mode = data.mode;



      });


  }
  processing = false;
  ngOnInit() {

    this.registry = this.route.snapshot.data.registry;


    if (this.registry && this.registry.paid && this.mode === 'pay'){
   //   this.router.navigateByUrl('/registry');
    }
  }

  checkTrailDays() {
    if (this.registry && this.registry.paid !== undefined && this.registry.paid === false) {

      this.daysLeft = this._registryFirebaseService.trialLeft(this.registry);


      if (this.daysLeft <= 0) {

      }

    }
   }


  getCurrency(countryCode) {
    if (countryCode === 'AU') {
      return 'AUD';
    } else if (countryCode === 'CA') {
      return 'CAD';
    } else if (countryCode === 'US') {
      return 'USD';
    } else if (countryCode === 'NZ') {
      return 'NZD';
    } else if (countryCode === 'GB') {
      return 'GBP';

    }
    else if (countryCode === 'DK') {
      return 'DKK';

    }
    else if (countryCode === 'MX') {
      return 'USD';
    }
    else {
      return 'EUR';
    }
  }


   getSymbol(countryCode) {
    if (countryCode === 'AU') {
      return '$';
    } else if (countryCode === 'CA') {
      return '$';
    } else if (countryCode === 'US') {
      return '$';
    } else if (countryCode === 'NZ') {
      return '$';
    } else if (countryCode === 'GB') {
      return '£';
    } else if (countryCode === 'DK'){
      return 'Kr ';
    } else {
      return '$';
    }
  }


  uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  upgradeAccount(type: string) {
    (window as any).stripe = Stripe(environment.stripePublicKey, {

    });

    this.type = type;
    this.processing = true;
    return fetch(environment.firebase.clouldFunctionHost + '/createCheckoutSession', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: 1,
        userAgent: navigator.userAgent,
        url: location.href,
        locale: 'auto',
        registryId: this.registry.id,
        source: this.registry.source,
        campaign: this.registry.campaign,
        partnershipId: this.registry.partnershipId,
        userId: this.registry.userId,
        uuid: this.uuid,
        country: this.country,
        isEu: this.isEu,
        type: this.type,
        hoursLeft: this.daysLeft,
        isUpgrade: this.mode === 'upgrade',
        fromTier: this.registry.tier ? this.registry.tier : null ,

      }),
    }).then((result) => {

      const reulst = result.json();
      reulst.then((x: any) => {
        const sessionId = x.sessionId;

        (window as any).stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: sessionId
        }).then(function (redirectResult) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        });
      //  return redirectResult.json();
      });


      }
      );
      //

    }

}



// WEBPACK FOOTER //
// ./src/app/hitchd--cards-payment-page/hitchd-cards-payment-page.component.ts